import { SCREEN_CONFIG } from '@config/screenConfig'
import { useLayoutIsXS } from '@segments/Responsive/client'
import { useWaiterRouter } from '@segments/Routing/client'
import * as React from 'react'

import { ScrollToTopButton } from '~shared/components/Buttons/ScrollToTopButton'
import {
  CartSummaryMobile,
  CartSummaryTablet,
  useCartModalControlsCtx,
} from '~shared/segments/Cart'

import { MenuModalCart } from './MenuModalCart'

type TProps = NoChildren

const moreThanCartSummaryHeight = `6rem`

/**
 * Cart component for the menu screen.
 * It shows the cart summary, button to open the cart modal,
 * but also a button to scroll to the top of the menu screen.
 */
export const MenuCart: React.FC<TProps> = () => {
  const isMobile = useLayoutIsXS()

  const router = useWaiterRouter()

  const navigateBack = React.useCallback(() => {
    router.back()
  }, [router])

  const { isDrawerOpen, closeDrawer, openDrawer } = useCartModalControlsCtx()

  return (
    <>
      {!isMobile && <CartSummaryTablet onCartButtonClick={openDrawer} />}

      <MenuModalCart isFullScreen={isMobile} isOpen={isDrawerOpen} onClose={closeDrawer} />

      {isMobile && !isDrawerOpen && (
        <CartSummaryMobile onBackClick={navigateBack} onCartButtonClick={openDrawer} />
      )}

      <ScrollToTopButton
        bottom={moreThanCartSummaryHeight}
        right={isMobile ? undefined : `5vw`}
        screenMaxContentWidth={SCREEN_CONFIG.maxContentWidth}
        marginRight={isMobile ? SCREEN_CONFIG.contentPaddingHorizontalMobile : undefined}
      />
    </>
  )
}
